// removed by extract-text-webpack-plugin
module.exports = {"nf-solicitation_grid_header-tooltip":"nf-solicitation_grid_header-tooltip"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/SolicitationsGrid/subcomponents/Header/Header.scss
// module id = 4924
// module chunks = 1